import { useState, useEffect, useCallback } from 'react';
import { screenTransitionDurationMs } from './_onboarding.style.js';
import { markOnboardingAsCompleted } from './_onboarding.utils.js';

const screens = [{
  animation: {
    src: "https://portalmotor.gyldendal.dk/-/media/home/web/idas-showroom/billeder/InSiteAd/2-Tilf%C3%B8j-anim.ashx",
    width: 260,
    height: 260
  },
  title: "Sammensæt dit forløb",
  body: "Tilføj indhold ved at klikke på plusserne og sammensæt forløb på tværs af portaler"
}, {
  animation: {
    src: "https://portalmotor.gyldendal.dk/-/media/home/web/idas-showroom/billeder/InSiteAd/3-Tilpas-anim.ashx",
    width: 260,
    height: 260
  },
  title: "Tilpas forløbet",
  body: "Tilpas dit forløb ved at tilføje eksternt indhold, omdøbe og flytte rundt på indholdet."
}, {
  animation: {
    src: "https://portalmotor.gyldendal.dk/-/media/home/web/idas-showroom/billeder/InSiteAd/4-Se-anim.ashx",
    width: 260,
    height: 260
  },
  title: "Se forløbet",
  body: "Klik på øjet og få vist forløbet, som eleverne ser det"
}, {
  animation: {
    src: "https://portalmotor.gyldendal.dk/-/media/home/web/idas-showroom/billeder/InSiteAd/5-Del-anim.ashx",
    width: 260,
    height: 260
  },
  title: "Del forløbet",
  body: "Del forløbet med elever og kollegaer"
}];

/**
 * Simple hook that manages the courseBuilder onboarding lifecycle.
 */
function useOnboarding(onCompleted) {
  const [currentIndex, setIndex] = useState(0);
  const [isTransitioning, setTransitioning] = useState(false);
  const canGoBack = currentIndex > 0;
  const canGoForwards = currentIndex < screens.length - 1;
  useEffect(() => {
    const timeout = window.setTimeout(() => {
      setTransitioning(false);
    }, screenTransitionDurationMs);
    return () => {
      window.clearTimeout(timeout);
    };
  }, [currentIndex]);
  const skip = useCallback(() => {
    onCompleted();
    markOnboardingAsCompleted();
  }, [onCompleted]);
  const next = useCallback(() => {
    if (!canGoForwards) {
      return;
    }
    setIndex(prev => prev + 1);
    setTransitioning(true);
  }, [canGoForwards]);
  const prev = useCallback(() => {
    if (!canGoBack) {
      return;
    }
    setIndex(prev => prev - 1);
    setTransitioning(true);
  }, [canGoBack]);
  return [screens[currentIndex], {
    canGoBack,
    canGoForwards,
    currentIndex,
    isTransitioning,
    totalScreens: screens.length
  }, {
    skip,
    next,
    prev
  }];
}

export { useOnboarding };
//# sourceMappingURL=_onboarding.hook.js.map
